// extracted by mini-css-extract-plugin
export var banner = "_do-0";
export var closeButton = "_do-2";
export var greenCheckmark = "_do-3";
export var hereLink = "_do-4";
export var titleIcon = "_do-1";